import { createSlice } from "@reduxjs/toolkit";
import { acceptRejectUserRequestThunk, getUserRequestThunk,resetRequestThunk,  getRequestDetailThunk} from "./thunk";

export const initialState = {

  error: null,
  isLoading: false,
  isSuccess: false,
  userRequestList:[],
  requestDetail:[]
};

const UserContestlice = createSlice({
  name: "userRequest",
  initialState,
  reducers: {
    resetFlags: (state) => {
      state.isLoading = false;
      state.error = null;
    },
  },

  extraReducers: (builder) => {

    // checkout User
    builder.addCase(getUserRequestThunk.pending, (state) => {
      state.isLoading = true;
      state.error = null;
      state.userRequestList=null;
    });
    builder.addCase(getUserRequestThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.userRequestList=action.payload.data;
    });
    builder.addCase(getUserRequestThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.userRequestList=null;
      state.error = action.payload || "Something went wrong";
    });

    // Accept Reject User
    builder.addCase(acceptRejectUserRequestThunk.pending, (state) => {
      state.isLoading = true;
      state.error = null;
      state.isSuccess=false;
    });
    builder.addCase(acceptRejectUserRequestThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.isSuccess = true;

    });
    builder.addCase(acceptRejectUserRequestThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.isSuccess=false;
      state.error = action.payload || "Something went wrong";
    });

    //Reset
     builder.addCase(resetRequestThunk.fulfilled, (state) => {
      state.isLoading = false;
      state.error = null;
      state.isSuccess=false;
    });

        //Request Detail
        builder.addCase(getRequestDetailThunk.pending, (state) => {
        state.isLoading = true;
        state.requestDetail=[];
    });

    builder.addCase(getRequestDetailThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.requestDetail=action.payload.data;

    });

    builder.addCase(getRequestDetailThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.requestDetail=[];
      state.error = action.payload || "Something went wrong";
    });

  },
});


export default UserContestlice.reducer;
